import React, { type FC } from 'react';
import { styled } from '@compiled/react';
import Epic24Icon from '@atlaskit/icon-object/glyph/epic/24';
import FileIcon from '@atlaskit/icon/glyph/file';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { type IntentTemplateType, INTENT_TEMPLATE_TYPES } from '../../types';
import messages from './messages';

export const TemplateIcon: FC<{ type: IntentTemplateType | undefined }> = ({ type }) => {
	const { formatMessage } = useIntl();

	return type === INTENT_TEMPLATE_TYPES.DISCOVERED ? (
		<Epic24Icon label={formatMessage(messages.discoveredIconLabel)} />
	) : (
		<FileIconContainer>
			<FileIcon
				label={formatMessage(messages.standardIconLabel)}
				primaryColor={token('color.icon.inverse', colors.N0)}
			/>
		</FileIconContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FileIconContainer = styled.div({
	width: token('space.300', '24px'),
	height: token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.icon.accent.green', colors.G300),
	borderRadius: token('border.radius.100', '4px'),
	flexShrink: 0,
});
